import { keyframes as o } from "styled-components";
const m = {
  open: o`
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  `,
  close: o`
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  `
}, c = {
  open: o`
    from {
      bottom: -100%;
    }

    to {
      bottom: 0;
    }
  `,
  close: o`
    from {
      bottom: 0;
    }

    to {
      bottom: -100%;
    }
  `
};
export {
  m as backdropAnimations,
  c as contentAnimations
};
